import React from 'react';
import { IPreviewContact, Nullable, } from 'atlas-shared';
import { TFunction, } from 'i18next';

export const getContactFullName: any = (contact: Nullable<IPreviewContact>, t: TFunction, skipUndefined: boolean = false) => contact ? (!contact.first_name && !contact.last_name) ? <span style={{ opacity: .25, }}>{t('NO_NAME')}</span> : [contact.first_name, contact.last_name, ].filter(Boolean).join(' ') : (skipUndefined ? '' : t('NO_CONTACT'));
